import React from 'react'
import ButtonWithLoader from './ButtonWithLoader'
import { DELETE_LESSON_PLAN } from '../redux/lessonPlansReducer'
import { useDispatch } from 'react-redux'

interface Props {
  onClose: () => void
  lessonPlanId: number
  unitId: number
}

const RemoveLessonPlanModal = ({ onClose, lessonPlanId, unitId }: Props) => {
  const dispatch = useDispatch()
  const handleDelete = () => {
    dispatch(DELETE_LESSON_PLAN({ lessonPlanId, unitId }))
    onClose()
  }
  return (
    <div>
      <div className="h-20" />
      <div className="bg-white rounded-md p-4 max-w-[27rem] w-screen">
        <h2 className="text-24 font-semibold">Delete Lesson Plan</h2>
        <div className="h-4" />
        <div className="text-14 font-semibold">Are you sure you want to delete this lesson plan?</div>
        <div className="h-4" />
        <div className="text-14 font-semibold">This action cannot be undone.</div>
        <div className="h-4" />
        <div className="flex justify-between mt-4">
          <div className="w-24">
            <ButtonWithLoader label="Close" onClick={onClose} />
          </div>
          <button onClick={handleDelete} className="bg-slateGray px-4 py-2 rounded-md text-white font-semibold">
            Delete
          </button>
        </div>
      </div>
    </div>
  )
}

export default RemoveLessonPlanModal
